import { defineStore } from 'pinia'
import type { TenantConfig } from '~~/types/tenant'
import { defaultTenantConfig } from '~~/overrides/config'

function copyConfig(config: TenantConfig): TenantConfig {
  return {
    name: config.name,
    domain: config.domain,
    features: { ...config.features },
    theme: config.theme ? { ...config.theme } : undefined,
  }
}

export const useTenantStore = defineStore('dedicatedTenant', {
  state: (): { config: TenantConfig } => ({
    config: copyConfig(defaultTenantConfig),
  }),

  actions: {
    setConfig(config: TenantConfig) {
      this.config = copyConfig(config)
    },
  },
})
